const everyTokenStyle = {
  section_wrapper: `w-full py-[30px] lg:py-[50px] px-4 bg-transparent flex flex-col items-center justify-center relative overflow-hidden`,
  container: `max-w-[1100px] w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center`,
  image_container: `relative w-full max-w-[500px] mx-auto md:mx-0 pb-10 md:pb-12`,
  main_image: `w-[82%] aspect-[4/5] object-cover shadow-lg border border-white/5`,
  overlap_image: `absolute right-0 bottom-0 w-[55%] aspect-square object-cover shadow-2xl border-[6px] border-[#020529]`,
  text_container: `flex flex-col justify-center items-start text-left w-full`,
  heading: `font-Suisse font-[900] uppercase text-[26px] leading-[34px] tracking-tight text-white mb-4
            screen-500:text-[32px] screen-500:leading-[40px]
            sm:text-[35px] sm:leading-[46px]
            md:text-[41px] md:leading-[52px]
            lg:text-[45px] lg:leading-[56px]`,
  divider: `w-[150px] h-[3px] bg-primaryHeading mb-6 md:mb-8`,
  description: `text-zinc-400 font-inter font-[400] text-[14px] leading-[22px] mb-8
                screen-500:text-[15px] screen-500:leading-[24px]
                md:text-[16px] md:leading-[26px]`,
  testimonial_container: `border-l-4 border-primaryHeading pl-5 py-1 mb-2 flex flex-col gap-2`,
  quote_text: `text-white font-inter italic font-[700] text-[15px] leading-[22px]
              screen-500:text-[16px] screen-500:leading-[24px]
              md:text-[18px] md:leading-[26px]`,
  citation: `text-zinc-500 font-inter font-bold text-[10px] md:text-[11px] tracking-[0.15em] uppercase`,
};

export { everyTokenStyle };
